export default "__VITE_PUBLIC_ASSET__1b1adb94__"